<template>
  <div id="forgotPassword" class="login">
    <div class="login-card row">
      <div class="login-card-logo col-md-7">
        <img v-img-fallback="{ loading: imgBaseUrl + 'pixel.png', error: imgBaseUrl + 'kerlink-light.png' }" :src="imgBaseUrl + 'logo/logo-light.png'" alt="Logo">

        <h4 class="mt-4 text-secondary text-center text-uppercase font-weight-bold">Wanesy Management Center</h4>
      </div>

      <div class="login-card-form col-md-5">
        <div v-show="error !== -1" class="form-group">
          <label class="control-label text-white" for="email">{{ $t('forgotPassword:enterEmail') | capitalize }}</label>
          <input id="email"
                 v-model="email"
                 v-validate="'required|email'"
                 :placeholder="$t('forgotPassword:email') | capitalize"
                 type="email"
                 class="form-control"
                 name="email"
                 @keyup.enter="send"
          >
        </div>

        <div v-show="errors.has('email')" class="alert alert-danger" role="alert">{{ errors.first('email') | capitalize }}</div>
        <div v-show="error === 404" class="alert alert-danger" role="alert">{{ $t('forgotPassword:unknownEmailError') | capitalize }}</div>
        <div v-show="error === 0" class="alert alert-danger" role="alert">{{ $t('forgotPassword:unknownError') | capitalize }}</div>

        <div v-show="error === -1" class="alert alert-info" role="alert">{{ $t('forgotPassword:emailSent', {email: email}) | capitalize }}</div>

        <button v-show="error !== -1" id="sendButton" type="button" class="btn btn-secondary btn-block" @click="send">{{ $t('forgotPassword:sendEmail') | capitalize }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import to from '@/modules/await-to-js'

export default {
  titleKey: 'forgotPassword',

  data () {
    return {
      email: '',
      error: null
    }
  },

  methods: {
    // Call API
    async send () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      let error
      [error] = await to(this.$api.forgotPassword(this.$store.getters.application, this.email, window.location.origin + '/#/resetPassword'))

      if (error) {
        this.error = error.response.status === 404 ? 404 : 0
        return
      }

      this.error = -1
    }
  }
}
</script>
